module.exports = __webpack_public_path__ + "img/input_10.fb6a2c29.png";